import React, { FC, useMemo } from 'react';

import { useLocation } from 'react-router-dom';

import useComposeMode from '../../../../hooks/router/search/useComposeMode';
import useComposeType from '../../../../hooks/router/search/useComposeType';

import translate from '../../../../i18n/translate';
import { getOpenComposeSectionUrl } from '../../../../routes/urls/searchParams/compose';
import Tabs from '../../../MUI/Tabs';

import { getComposeModalTabs } from './helpers';
import { Props } from './types';

/**
 * Compose modal tabs
 *
 * @param props          Props passed to the component
 * @param props.nodeType The type of node [MESSAGE, TEMPLATE]
 * @param props.topicId  The ID of the topic
 * @returns              Component itself
 */
const ComposeModalTabs: FC<Props> = ({ nodeType, topicId }) => {
  const composeMode = useComposeMode();
  const composeType = useComposeType();
  const location = useLocation();

  const tabs = useMemo(() => {
    if (composeType === null) {
      return [];
    }
    return getComposeModalTabs(nodeType, composeType);
  }, [composeType, nodeType]);

  const selectedTab = useMemo(() => {
    if (composeMode === null) {
      return 0;
    }
    return tabs.findIndex(tab => tab.mode === composeMode);
  }, [composeMode, tabs]);

  const composeTabs = tabs.map(({ Component, icon, label, mode }) => ({
    content: <Component nodeType={nodeType} topicId={topicId} />,
    icon,
    label: translate(label),
    url: getOpenComposeSectionUrl(location, mode),
  }));

  return <Tabs selectedTab={selectedTab} tabs={composeTabs} />;
};

export default ComposeModalTabs;
